export default __webpack_public_path__ + "static/media/account.5fc94bd4.svg";